
  import { Vue, Component, Prop } from "vue-property-decorator";
  import api from "@/api";
  import { axios, getConfigs, IRequestConfig } from "@/api/appService";

  @Component({ name: "DataBoxSimple" })
  export default class DataBoxSimple extends Vue {
    // props
    @Prop({ required: true })
    backgroundColor!: string;

    @Prop({required:true})
    icon!:string;

    @Prop({ required: true })
    unit!: string;

    @Prop({ default: "get" })
    apiMethod!: string;

    @Prop({ default: "normal" })
    size!: string;

    @Prop({ required: true })
    apiUrl!: string;

    @Prop({ required: true })
    title!: string;

    @Prop()
    tooltip!:string;



    @Prop({ default: {} })
    apiParameters!: object;



    // private members
    value: any = 0;
    loading: boolean = true;

    created() {
      this.fetchData();
    }

    get dataBoxClass() {
      const classes: any = {
        small: this.size === "small",
        normal: this.size === "normal"
      };
      classes[this.backgroundColor] = true;
      return classes;
    }


    async fetchData() {
      this.loading = true;
      await this.createApiRequest().then(res => {
        this.value = res;
        this.loading = false;
      });
    }

    createApiRequest() {
      return new Promise((resolve, reject) => {
        let url = this.apiUrl;

        const configs: IRequestConfig = getConfigs(
          this.apiMethod,
          "application/json",
          url,
          {}
        );
        configs.params = Object.assign({}, this.apiParameters);
        let data = null;

        configs.data = data;
        axios(configs, resolve, reject);
      });
    }
  }
